import {
  AccountCreationConfirmationError,
  AccountCreationConfirmationRequest,
} from "@planzone/dto";

function isAddressMissing(
  request: AccountCreationConfirmationRequest,
): boolean {
  return request.hasRequestedPlanzoneCreation && !request.address;
}

function isCompanyValid(company: string): boolean {
  return !!company;
}

function isPasswordValid(password: string): boolean {
  return !!password;
}

function isPasswordConfirmationValid(
  request: AccountCreationConfirmationRequest,
): boolean {
  return (
    request.password === request.passwordConfirmation &&
    !!request.passwordConfirmation
  );
}

function isUsernameValid(username: string): boolean {
  return !!username;
}

function validateAccount(request: AccountCreationConfirmationRequest): {
  isAddressMissing: boolean;
  isCompanyInvalid: boolean;
  isPasswordConfirmationInvalid: boolean;
  isPasswordInvalid: boolean;
  isUsernameInvalid: boolean;
} {
  return {
    isAddressMissing: isAddressMissing(request),
    isCompanyInvalid: !isCompanyValid(request.companyName),
    isPasswordConfirmationInvalid: !isPasswordConfirmationValid(request),
    isPasswordInvalid: !isPasswordValid(request.password),
    isUsernameInvalid: !isUsernameValid(request.username),
  };
}

function isDomainValid(request: AccountCreationConfirmationRequest): boolean {
  return !request.hasRequestedPlanzoneCreation
    ? true
    : !!request.planzone.domain;
}

function isNameValid(request: AccountCreationConfirmationRequest): boolean {
  return !request.hasRequestedPlanzoneCreation ? true : !!request.planzone.name;
}

function validatePlanzone(request: AccountCreationConfirmationRequest): {
  isDomainInvalid: boolean;
  isNameInvalid: boolean;
} {
  return {
    isDomainInvalid: !isDomainValid(request),
    isNameInvalid: !isNameValid(request),
  };
}

function validateAccountCreationConfirmationRequest(
  request: AccountCreationConfirmationRequest,
): AccountCreationConfirmationError {
  return {
    isAccountInvalid: validateAccount(request),
    isPlanzoneInvalid: validatePlanzone(request),
    message: "",
  };
}

export { validateAccountCreationConfirmationRequest };
